import i18next from "i18next";
import "../../swiper/swiper.css";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { TAJIKISTAN_ATTRACTIONS } from "../../../info/tajikistanAttractions";
import {
  Card,
  CardDesc,
  CardEmoji,
  CardName,
  CardRegion,
  Title,
  Wrapper,
} from "./style";

export const AttractionsCarouselComponent = () => {
  const { t, language } = i18next;

  return (
    <Wrapper>
      <Title>{t("tajikistan_attractions")}</Title>
      <Swiper
        modules={[Autoplay, Navigation, Pagination]}
        spaceBetween={16}
        slidesPerView={5}
        autoplay={{ delay: 3500, disableOnInteraction: false }}
        breakpoints={{
          300: { slidesPerView: 1, spaceBetween: 12 },
          600: { slidesPerView: 2, spaceBetween: 14 },
          900: { slidesPerView: 3, spaceBetween: 16 },
          1200: { slidesPerView: 4, spaceBetween: 16 },
          1500: { slidesPerView: 5, spaceBetween: 16 },
        }}
        pagination={{ clickable: true }}
        draggable={true}
        keyboard={true}
        className="attractions-swiper"
        style={{ alignItems: "stretch" }}
      >
        {TAJIKISTAN_ATTRACTIONS.map(attraction => (
          <SwiperSlide key={attraction.id}>
            <Card>
              <CardEmoji>{attraction.emoji}</CardEmoji>
              <CardName>{attraction.name[language]}</CardName>
              <CardDesc>{attraction.desc[language]}</CardDesc>
              <CardRegion>📍 {attraction.region[language]}</CardRegion>
            </Card>
          </SwiperSlide>
        ))}
      </Swiper>
    </Wrapper>
  );
};
